/**
 * 多语言 favicon
 *
 * @module components/localized-favicon
 */
import { useEffect } from 'react';

import { useLocalizedAssetResolver } from '@/locales/assets';

/** 随当前语言图片配置更新浏览器 favicon。 */
export const LocalizedFavicon = () => {
  const assetUrl = useLocalizedAssetResolver();
  const faviconHref = assetUrl('global.favicon');

  useEffect(() => {
    if (!faviconHref) return;

    /** 创建或更新指定 rel 的 favicon 链接。 */
    const applyFavicon = (rel: 'icon' | 'shortcut icon') => {
      let link = document.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
      if (!link) {
        link = document.createElement('link');
        link.rel = rel;
        document.head.appendChild(link);
      }
      link.href = faviconHref;
    };

    applyFavicon('icon');
    applyFavicon('shortcut icon');
  }, [faviconHref]);

  return null;
};
